import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "motion/react";

import { router, Toaster } from "@/App";
import { AuthProvider } from "@/lib/store/auth-store";
// Self-hosted brand fonts via @fontsource (no 3rd-party CDN). Weights mirror
// the design spec: Inter 400/500/600/700, JetBrains Mono 400/500/600. Family
// names ('Inter', 'JetBrains Mono') match styles/tokens.css --font-*.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
// MapLibre base structural CSS (canvas positioning + sizing, controls, popups).
// Imported EAGERLY here rather than lazily inside ProximiioMap so code-splitting
// the map surface can never leave the canvas unsized (which renders as a blank
// grey map). App CSS below still overrides it (later + higher specificity).
import "maplibre-gl/dist/maplibre-gl.css";
// Import order is load-bearing (ported from kalista/web/main.tsx):
//   1. tokens.css declares the OKLCH design vars tailwind reads via var(--*).
//   2. index.css runs @tailwind base/components/utilities + the base layer.
//   3. ds.css LAST so DS helpers win over equal-specificity Tailwind utils.
import "./styles/tokens.css";
import "./index.css";
import "./styles/ds.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* `reducedMotion="user"` makes every Framer Motion animation (Phase B+)
        honour prefers-reduced-motion globally, matching the CSS reset. */}
    <MotionConfig reducedMotion="user">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster />
        </AuthProvider>
      </QueryClientProvider>
    </MotionConfig>
  </React.StrictMode>,
);
